import React from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { NoticeBanner } from "../components/NoticeBanner";
import { Outlet } from "react-router-dom";

// `mt-20` matches IncomeTaxLayout / GSTLayout / TDSLayout so the
// `/team` page sits the same distance below the fixed Navbar as the
// IT/GST/TDS notice-list pages — was `marginTop: "132px"` previously,
// which left ~52 px of extra empty space above the breadcrumb on /team
// vs every other tenant page.
export const MainLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen relative">
      <Navbar />

      <main className="flex-1 mt-20 p-6">
        {<Outlet />}
      </main>
      <Footer />
    </div>
  );
};
